module.exports = __webpack_public_path__ + "img/showbill3.1a8f987a.jpg";